<template>
  <div class="tekenaarsheader">
    <div class="headerleft">
      <div class="ico" style="padding:6px;">
        <img style="padding-bottom:4px;" src="../../assets/sidebar/links-ico.png" alt />
      </div>
      <h2 class="header">CDT Gereedschappen</h2>
    </div>
    <!-- <SearchfieldWithReset2 :filterOn="tekFilters.name" filterBy="name" /> -->
    <!-- <SearchfieldWithReset :filterOn="tekFilters.name" filterBy="name" /> -->
  </div>
</template>

<script>
import store from '@/store';
//import SearchfieldWithReset from './SearchfieldWithReset'

export default {
  name: 'ToolsHeader',
  components: {
    // SearchfieldWithReset,
  },
  computed: {
    tekFilters() {
      return store.state.tekFilters;
    }
  },
  methods: {
    fixupdate(e) {
      store.state.tekFilters.name = e;
    }
  }
};
</script>

<style scoped>
.header {
  color: #0b1125;
  opacity: 0.8;
  font-weight: 600;
  padding-right: 30px;
  font-size: 26px;
}
.headerleft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ico {
  background-color: #ff9326;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  padding: 4px;
  margin-right: 10px;
}

.tekenaarsheader {
  z-index: 2;
  /* background-color: #FAFCFE; */
  background-color: #eff2f5;
  position: fixed;
  top: 0;
  display: flex;
  width: 100%;
  height: 70px;
  align-items: center;
  padding: 50px 40px;
  /* border-bottom: 1px solid #E7E7F3; */
}

.searchbarholder {
  position: relative;
}
.reset-btn {
  position: absolute;
  width: 24px;
  height: 24px;
  top: 8px;
  right: 10px;
  cursor: pointer;
}
.searchfield {
  width: 200px;
  height: 40px;
  background-color: #e4ecfa;
  border-radius: 100px;
  border: none;
  font-size: 14px;
  padding: 10px 10px 10px 14px;
}
.active {
  background-color: #3076ea;
  color: white;
}
</style>
